import { useEffect, useRef } from 'react'
import { trackError } from '@vend/utilities'
import { $stateParams } from '../../../../ng-compat/imports'
import { LSPaymentProps } from './useTransactionRecovery'

type QuickPayProps = LSPaymentProps & {
  /** Fail-closed lock (e.g. sale ACH fetch loading / error / leftover $0). */
  disabled?: boolean
}

/**
 * Hook to handle lspay quick pay on payment page
 * Run once only when lspayPaymentType is set and the pay path is unlocked.
 */
export const useLSPayQuickPay = (props: QuickPayProps) => {
  const { lspayPaymentType, pay, disabled = false } = props
  const ref = useRef(false)

  useEffect(() => {
    if (ref.current || !lspayPaymentType || disabled) {
      return
    }

    try {
      if ($stateParams.lspayQuickPaySelected) {
        pay(lspayPaymentType)
      }
    } catch (error) {
      trackError('Failed to complete a quick pay transaction with LSPay', {
        error,
      })
    } finally {
      ref.current = true
    }
  }, [lspayPaymentType, pay, disabled])
}
